var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.332682 7.9172H13.5168L7.46101 1.86136L8.99935 0.333862L17.666 9.00053L8.99935 17.6672L7.47185 16.1397L13.5168 10.0839H0.332682V7.9172Z",
    fill: "#232735"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextarrow);
export default __webpack_public_path__ + "static/media/nextarrow.f129cee1b1a806236f503d2db7960228.svg";
export { ForwardRef as ReactComponent };